export const SIDEBAR = {
  width: 248,
  collapsedWidth: 72,
  iconWidth: 40,
  itemTextMargin: 16,
  basePadding: 8,
};

export const TRANSITION_SPEED = 0.3;
